import PropTypes from "prop-types";

const SectionCardSkeleton = ({ children, className = "" }) => (
    <div className={`rounded-2xl border border-[#f0f0f0] bg-white p-4 lg:p-5 ${className}`}>{children}</div>
);

SectionCardSkeleton.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default SectionCardSkeleton;
